export default {
  SET_ROLES_WITH_PAGINATION(state, data) {
    const items = data.data;
    items.map((element) => {
      element.metas.map((item) => {
        element[item.meta_key] = item.meta_value;
      });
    });
    state.roles = items ? items : [];
    state.pagination = data.pagination ? data.pagination : {};
  },
  SET_ROLES(state, data) {
    state.roles = data ? data : [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  ADD_ROLE(state, role) {
    state.roles.push(role);
  },
  UPDATE_ROLE(state, role) {
    const rolesIndex = state.roles.findIndex((u) => u.id === role.id);
    Object.assign(state.roles[rolesIndex], role);
  },
  REMOVE_RECORD(state, itemId) {
    const roleIndex = state.roles.findIndex((u) => u.id === itemId);
    state.roles.splice(roleIndex, 1);
  },
  SET_PERMISSION(state, data) {
    state.permissions = data ? data : [];
  },
};
